import { BatchDefinitionListState } from 'ducks/batch-definition-list/slices';
import { CardInfoParams } from 'ducks/types/common-types';
import { BatchDefinitionItemCheckDep } from 'ducks/types/store-types';

export const normalizeBatchFromBatches = (
  batch_definition_list: BatchDefinitionListState,
  batch_definition_deps: BatchDefinitionItemCheckDep[],
) => {
  const res = Object.keys(batch_definition_list).map((key) => batch_definition_list[key]);
  res.map((el) => {
    Object.values(batch_definition_deps).map((elem) => {
      if (el.batch_definition_item_id === elem.currentId) {
        el.children_item_ids = elem.children ? [elem.children] : [];
        el.parent_item_ids = [];
        el.parent_items_count = 0;
        el.upstream_parents = [];
        el.children_items_count = elem?.children || 0;
        el.exisiting_card = true;
        el.children_params = elem.children_params || [];
        el.current_params = elem.current_params || [];
      }
    });
  });
  res.map((e) => {
    Object.values(batch_definition_deps).map((elem) => {
      if (e.batch_definition_item_id === elem.children) {
        e.parent_item_ids = [elem.currentId];
        e.parent_items_count = 1;
        e.upstream_parents = [];
        e.exisiting_card = true;
      }
    });
  });
  return res;
};

export const normalizeParamsConnection = (
  parent: (number | CardInfoParams)[],
  children: CardInfoParams[],
): (number | CardInfoParams)[] => {
  const connect: (number | CardInfoParams)[] = [];
  const noConnect: CardInfoParams[] = [];
  children?.map((el) => {
    const c = parent?.find((elem) => {
      if (typeof elem === 'number') return;
      return elem?.parameter_name === el?.parameter_name;
    });

    if (c) {
      connect.push(c);
    } else {
      connect.push(0);
      noConnect.push(el);
    }
  });

  return [...connect, ...noConnect];
};
